/** basic.deviceCheck */
export default {
    check_checkMid: "Идёт проверка качества",
    check_needCheck: "Устройства для проверки",
    check_paramsTitle: "Параметры проверки",
    check_backProduction: "Вернуться к производству",
    check_back: "Назад",
    check_confirmTitle: "Подсказка",
    check_selectEntity: "Выбрать организацию",
    check_entityPlaceholder: "Организация не выбрана",
    check_remark: "Примечание",
    check_export: "Экспорт",
    check_exportEmpty: "Нет данных для экспорта",
    check_tableFontSize: "Размер шрифта таблицы",
    check_total: "Итого",
    check_needCheckPla: "Введите imei устройства...",
    check_matchImei: "Сопоставлять IMEI",
    check_noMatchImei: "Не сопоставлять IMEI",
    check_inputEmpty: "Сначала введите imei устройства!",
    check_lowSignal: "Минимальный уровень сигнала",
    check_lowVoltage: "Минимальное напряжение (мВ)",
    check_checkDayHearbeat: "Проверять heartbeat за 24 часа",
    check_qualityTesting: "Проверять данные качества",
    check_alarmData: "Проверять данные тревог",
    check_checkMainPower: "Проверять неисправность основного питания",
    check_checkTamper: "Проверять неисправность снятия/вскрытия",
    check_normalDevice: "Нормальные устройства",
    check_importClient: "Импорт клиента",
    check_clearTableTips: "Очистить таблицу нормальных устройств?",
    check_clearTable: "Очистить таблицу",
    check_abnormalDevice: "Аномальные устройства",
    check_abnormalNews: "Информация об аномалиях",
    check_selectDevcieType: "Выберите тип устройства",
    check_deviceFormatLose: "Неверный формат устройства!",
    check_qualitySucc: "Проверка завершена!",
    check_qualityLose: "Проверка не удалась!",
    messge_qualitySucc: "Устройство уже проверено!",
    check_desc_uncheck: "Не проверено",
    check_desc_success: "Норма",
    check_desc_error: "Аномалия",
}

